import { gql } from '@apollo/client'

export const GET_CURRENT_FANTASY_LEAGUE_MEMBER = gql`
  query GetCurrentFantasyLeagueMember($fantasyLeagueId: ID!) {
    currentFantasyLeagueMember(fantasyLeagueId: $fantasyLeagueId) {
      id
      budget
    }
  }
`
